import { useEffect, useState } from "react";

const navLinks = [
  { label: "作品简介", href: "#intro" },
  { label: "观看入口", href: "#access" },
  { label: "资源导航", href: "#resources" },
  { label: "无删减说明", href: "#uncut" },
  { label: "角色一览", href: "#characters" },
  { label: "剧情看点", href: "#timeline" },
  { label: "常见问题", href: "#faq" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const solid = scrolled || menuOpen;

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        solid ? "border-b border-background-200 bg-background-50/95 backdrop-blur" : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex h-16 items-center justify-between px-4 md:px-8">
        <a
          href="#top"
          className={`flex items-center gap-2 whitespace-nowrap font-heading text-lg font-bold tracking-wide transition-colors ${
            solid ? "text-foreground-950" : "text-background-50"
          }`}
        >
          <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-book-marked-line text-lg"></i>
          </span>
          风流女管家
        </a>

        <ul className="hidden items-center gap-1 lg:flex">
          {navLinks.map((link) => (
            <li key={link.href}>
              <a
                href={link.href}
                className={`whitespace-nowrap rounded-md px-3 py-2 font-label text-sm transition-colors ${
                  solid
                    ? "text-foreground-700 hover:bg-background-100 hover:text-primary-700"
                    : "text-background-100 hover:bg-background-50/15 hover:text-background-50"
                }`}
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="flex items-center gap-2">
          <a
            href="#resources"
            className="hidden cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:inline-flex dark:text-foreground-950"
          >
            快速找资源
          </a>
          <button
            type="button"
            aria-label="打开导航菜单"
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((v) => !v)}
            className={`flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border transition-colors lg:hidden ${
              solid
                ? "border-background-200 text-foreground-900 hover:bg-background-100"
                : "border-background-50/40 text-background-50 hover:bg-background-50/15"
            }`}
          >
            <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
          </button>
        </div>
      </nav>

      {menuOpen ? (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 lg:hidden">
          <ul className="flex flex-col">
            {navLinks.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  onClick={() => setMenuOpen(false)}
                  className="block rounded-md px-3 py-3 font-label text-sm text-foreground-800 transition-colors hover:bg-background-100 hover:text-primary-700"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
          <a
            href="#resources"
            onClick={() => setMenuOpen(false)}
            className="mt-2 block cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-4 py-3 text-center font-label text-sm font-medium text-background-50 dark:text-foreground-950"
          >
            快速找资源
          </a>
        </div>
      ) : null}
    </header>
  );
}